import { PendingQrCode } from "../../interfaces/Sockets.interfaces";

export type PendingQrCodes = Record<string, PendingQrCode>;

// QR codes are renewed every ~20s while a number waits; an older one no longer pairs.
export const QR_EXPIRATION_MS = 2 * 60_000;

export function addPendingQr(current: PendingQrCodes, number: string, qr: string, now: number): PendingQrCodes {
    return { ...current, [number]: { number, qr, receivedAt: now } };
};

export function removePendingQrs(current: PendingQrCodes, numbers: Array<string>): PendingQrCodes {
    const next = { ...current };
    numbers.forEach((number) => delete next[number]);

    return next;
};

export function getExpiredQrNumbers(current: PendingQrCodes, now: number): Array<string> {
    return Object.values(current)
        .filter((pending) => now - pending.receivedAt > QR_EXPIRATION_MS)
        .map((pending) => pending.number);
};
